import React from "react";
import SearchSelect from "../generics/SearchSelect";
import PurchaseOrderPrint from "./PurchaseOrderPrint";

const PurchaseOrderInputBox = (props) => {
  var inputStyle = { zIndex: 0 };
  return (
    <div>
      <h5>{props.editingItem ? "Edit Item" : "Add item"}</h5>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-block">
              <form className="row">
                {props.editingItem ? (
                  <div className="col-sm-6 form-group row">
                    <label className="col-sm-4 col-form-label" htmlFor="text-input">
                      Item
                    </label>
                    <div className="col-sm-8">
                      <input disabled type="text" id="text-input" name="text-input" className="form-control" value={props.itemName} />
                    </div>
                  </div>
                ) : (
                  <SearchSelect
                    onChange={props.onItemChange}
                    getOptions={props.searchItems}
                    isLoading={props.isLoadingItems}
                    value={props.selectedItem}
                    error={props.errors.indexOf("item") !== -1}
                    class={props.errors.indexOf("item") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}
                    classLabel="col-sm-4 col-form-label"
                    classInput="col-sm-8"
                    label="Item"
                  />
                )}

                {props.hasGrade && (
                  <div className={props.errors.indexOf("grade") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="select">
                      Grade
                    </label>
                    <div className="col-sm-8">
                      <select
                        id="select"
                        name="select"
                        className={props.errors.indexOf("grade") !== -1 ? "form-control form-control-danger" : "form-control"}
                        size="1"
                        value={props.grade}
                        onChange={(grade) => props.onGradeChange(grade)}
                      >
                        <option value={-1}>Select grade</option>
                        {props.grades ? (
                          props.grades.map((grade) => {
                            return (
                              <option value={grade.id} key={grade.id}>
                                {grade.grade}
                              </option>
                            );
                          })
                        ) : (
                          <option value=" ">Loading...</option>
                        )}
                      </select>
                    </div>
                    {props.errors.indexOf("grade") !== -1 ? (
                      <em id="firstname-error" className="error form-control-feedback">
                        Please select Grade
                      </em>
                    ) : (
                      <em></em>
                    )}
                  </div>
                )}

                <div className={props.errors.indexOf("quantity") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                    Quantity
                  </label>
                  <div className="col-sm-6 col-10">
                    <input
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={props.errors.indexOf("quantity") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Enter quantity"
                      value={props.quantity}
                      onChange={(item) => props.onQuantityChange(item, props.index)}
                    />
                  </div>
                  <div className="d-flex align-items-center">{props.presentation ? props.presentation : "Case"}</div>
                  {props.errors.indexOf("quantity") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please enter a positive integer value.
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>

                <div
                  className={props.errors.indexOf("numberItems") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}
                >
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Pieces
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={props.errors.indexOf("numberItems") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Enter number of items"
                      value={props.numberItems}
                      onChange={(item) => props.onNumberItemsChange(item, props.index)}
                    />
                  </div>
                  {props.errors.indexOf("numberItems") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please enter a positive integer value.
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>

                <div className={props.errors.indexOf("brand") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="select">
                    Manufacturer
                  </label>
                  <div className="col-sm-8">
                    <select
                      id="select"
                      name="select"
                      className={props.errors.indexOf("brand") !== -1 ? "form-control form-control-danger" : "form-control"}
                      size="1"
                      value={props.brand}
                      onChange={(brand) => props.onBrandChange(brand)}
                    >
                      <option value={-1}>Select brand</option>
                      {props.brands ? (
                        props.brands.map((brand) => {
                          return (
                            <option value={brand.id} key={brand.id}>
                              {brand.brand_name}
                            </option>
                          );
                        })
                      ) : (
                        <option value=" ">Loading...</option>
                      )}
                    </select>
                  </div>
                  {props.errors.indexOf("brand") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please select Brand
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>

                <div className={props.errors.indexOf("price") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Unit Price
                  </label>
                  <div className="col-sm-8 input-group">
                    <div className="input-group-addon">$</div>
                    <input
                      style={inputStyle}
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={props.errors.indexOf("price") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Unit price"
                      value={props.price}
                      onChange={(price) => props.onPriceChange(price)}
                      onBlur={props.handlePriceChange}
                    />
                  </div>
                  {props.errors.indexOf("price") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">Please enter a positive value</em>
                  ) : (<em></em>)}
                </div>
              </form>

              {props.editingItem ? (
                <div className="add-repeat-btn">
                  <span className="btn btn-danger m-0" onClick={() => props.cancelEditItem()}>
                    Cancel
                  </span>
                  <div className="pl-h">
                    <span className="btn btn-primary m-0" onClick={() => props.updateItem()}>
                      Update
                    </span>
                  </div>
                </div>
              ) : (
                <div className="add-repeat-btn">
                  <span className="btn btn-primary m-0" onClick={() => props.addItem()}>
                    Add
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderInputBox;
